/******************************************************************************************
 *	Customer Loyalty Programs
 ******************************************************************************************/
(function() {
  

  angular
    .module('rcServices.customerLoyaltyPrograms', [])
    .constant('THREE_YEAR_COMMIT_STATUSES', {
      ELIGIBLE: 'ELIGIBLE',
      ENROLLED: 'ENROLLED'
    })
    .factory(
      'CustomerLoyaltyPrograms',
      /* @ngInject */
      function(_, THREE_YEAR_COMMIT_STATUSES) {
        //Map of known program names and features to JIL API output
        //Format is JIL_NAME:'INTERNAL_NAME'.
        var JIL_PROGRAM_NAMES = {
          BASIC: 'BASIC',
          SELECT: 'SELECT'
        };
        var JIL_PROGRAM_FEATURES = {
          DISCOUNT: 'DISCOUNT',
          THREE_YEAR_COMMIT: 'THREE_YEAR_COMMIT'
        };

        //Program names used as keys in instances of LoyaltyPrograms.
        //The difference to `JIL_PROGRAM_NAMES` is that `PROGRAMS` has names which are
        //allowed / safe to use as object keys, whereas `JIL_PROGRAM_NAMES` is a mapping
        //to the JIL API output which isn't guaranteed to work as object keys.
        var PROGRAMS = {
          BASIC: 'BASIC',
          SELECT: 'SELECT'
        };

        //Syntactic sugar for `Object.defineProperty` with `enumerable` set to `true`.
        var defineEnumerableProperty = function(obj, propertyName, value) {
          Object.defineProperty(obj, propertyName, {
            value: value,
            enumerable: true,
            configurable: false, //configurable and writable are `false` by default, added for clarity.
            writable: false
          });
        };

        //Factory constructor
        function LoyaltyPrograms(loyaltyPrograms) {
          //Expecting array of loyalty programs
          if (!_.isArray(loyaltyPrograms)) {
            return null;
          }

          _.forEach(loyaltyPrograms, program => {
            var programName = _.toUpper(program.name);
            switch (programName) {
              case JIL_PROGRAM_NAMES.BASIC:
                defineEnumerableProperty(this, PROGRAMS.BASIC, new BasicLoyaltyProgram(program));
                break;
              case JIL_PROGRAM_NAMES.SELECT:
                defineEnumerableProperty(this, PROGRAMS.SELECT, new SelectLoyaltyProgram(program));
                break;
            }
          });
        }

        //Add program names to factory so they are accessible like "static" properties
        for (var programName in PROGRAMS) {
          defineEnumerableProperty(LoyaltyPrograms, programName, PROGRAMS[programName]);
        }

        /*=== BASIC "Program" ===*/
        function BasicLoyaltyProgram() {
          this.name = JIL_PROGRAM_NAMES.BASIC;
        }

        /*=== SELECT Program ===*/
        function SelectLoyaltyProgram(data) {
          this.name = JIL_PROGRAM_NAMES.SELECT;
          this.level = null; //Select level that is to be displayed. Taken from discount level.
          this.features = {}; //Map of features available

          //Iterate features array and map it to this.features object map
          var featuresArray = _.isArray(data.features) ? data.features : null;
          if (featuresArray) {
            for (var i = 0, count = featuresArray.length; i < count; i++) {
              var featureName = _.toUpper(featuresArray[i].name);

              //Determine this.level
              if (featureName === JIL_PROGRAM_FEATURES.DISCOUNT) {
                this.level = featuresArray[i].level;
              }

              //Map known features
              if (JIL_PROGRAM_FEATURES.hasOwnProperty(featureName)) {
                this.features[JIL_PROGRAM_FEATURES[featureName]] = featuresArray[i];
              }
            }
          }

          // VIP Select
          this.toNameString = _.constant('customerLoyaltyPrograms.select.name');

          // Level {{level}} for all select levels
          this.toLevelString = function() {
            if (this.level) {
              return 'customerLoyaltyPrograms.select.level';
            }
            return '';
          };

          //  VIP Select - Level {{level}} for all select levels
          this.toString = function() {
            if (this.level) {
              return 'customerLoyaltyPrograms.select.nameAndLevel';
            }
            return 'customerLoyaltyPrograms.select.name';
          };

          // 3YC helpers
          this.hasThreeYearCommit = function() {
            return !!(this.features && this.features[JIL_PROGRAM_FEATURES.THREE_YEAR_COMMIT]);
          };

          this.isEnrolledThreeYearCommit = function() {
            return (
              this.hasThreeYearCommit() &&
              this.features[JIL_PROGRAM_FEATURES.THREE_YEAR_COMMIT].status ===
                THREE_YEAR_COMMIT_STATUSES.ENROLLED
            );
          };

          this.isEligibleThreeYearCommit = function() {
            return (
              this.hasThreeYearCommit() &&
              this.features[JIL_PROGRAM_FEATURES.THREE_YEAR_COMMIT].status ===
                THREE_YEAR_COMMIT_STATUSES.ELIGIBLE
            );
          };
        }

        return LoyaltyPrograms;
      }
    );
})();
